import { CollectionViewer, DataSource } from "@angular/cdk/collections";
import { Observable, BehaviorSubject, of } from "rxjs";
import { catchError, finalize } from "rxjs/operators";

import { HealthService } from './health.service';
import { HealthArticle } from '@app/_models/health';



export class HealthDataSource implements DataSource<HealthArticle> {

  private healthSubject = new BehaviorSubject<HealthArticle[]>([]);
  private loadingSubject = new BehaviorSubject<boolean>(false);
  public loading$ = this.loadingSubject.asObservable();

  constructor(private _healthService: HealthService) {
  }

  loadHealthArticles(
    pageIndex: number = 0,
    pageSize: number = 10,
    status = -1): Promise<number> {
    return new Promise((resolve, reject) => {
      this.loadingSubject.next(true);
      pageIndex += 1;
      this._healthService.findHealthArticles(pageIndex, pageSize, status)
        .pipe(
          catchError(() => of([])),
          finalize(() => this.loadingSubject.next(false))
        )
        .subscribe(healthArticles => {
          this.healthSubject.next(healthArticles);
          resolve(healthArticles.length);
        });
    });

  }

  connect(collectionViewer: CollectionViewer): Observable<HealthArticle[]> {
    return this.healthSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.healthSubject.complete();
    this.loadingSubject.complete();
  }

}